import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=dc7d528a&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=ts"
export * from "./Payment.vue?vue&type=script&lang=ts"
import style0 from "./Payment.vue?vue&type=style&index=0&id=dc7d528a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7d528a",
  null
  
)

export default component.exports